module.exports = __webpack_public_path__ + "static/media/19.2071a7da.jpg";